module.exports = __webpack_public_path__ + "img/gt-r-wheel.2def8f22.jpg";